

















import { defineComponent, computed } from '@vue/composition-api'
export default defineComponent({
  props: {
    text: { type: String, default: '???' },
    bgcolor: { type: String, default: '#eb73a3' },
    isOpen: { type: Boolean, default: false }
  },
  setup (props) {
    const displayText = computed(() => {
      return props.text.replace(/\/\//g, '\n')
    })
    return {
      displayText
    }
  }
})
